<!-- Patient Header Configurable Sections-->
@if (sections.length > 0 && !patientRestricted && !patientOptedOutAndRestricted)
{
    <div class="row">
        @for (section of sections; let i = $index; track section)
        {
            <ng-container *ngTemplateOutlet="headerSectionTemplate; context: { section: section, member: member, loadedFields: loadedFields, 
                showSeparator: (i >= 1 && sections[i].fields.length > 0)}"></ng-container>
        }
    </div>
}

<!-- Patient Header Configurable Fields -->
<ng-template #headerSectionTemplate let-section="section" let-member="member" let-loadedFields="loadedFields" let-index="index" let-showSeparator="showSeparator">
    <div [ngClass]="{'left-separator': showSeparator, 
        'col-12': usedSections === 1, 'col-6': usedSections === 2, 'col-4': usedSections === 3}">
        @for (field of section.fields; track field)
        {
            @if (field)
            {
                <ng-container *ngTemplateOutlet="fieldTemplate; context: { field: field, member: member, fieldLabel: loadedFields.get(field)?.text }"></ng-container>
            }
        }
    </div>
</ng-template>

<!-- Patient Header Field Template -->
<ng-template #fieldTemplate let-field="field" let-member="member" let-fieldLabel="fieldLabel">
    @if (isHeaderIdentifierField(field)) 
    {
        @let identifier = identifiersMap.get(field);
        <ng-container *ngTemplateOutlet="standardRenderer; context: { value: identifier?.value, label: identifier?.label }"></ng-container>
    } 
    @else 
    {
        @switch (field)
        {
            @case ('GENDER')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member.gender?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('HOME_PHONE')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.contact?.homePhoneNumber | phone, label: fieldLabel, safe: member?.homePhoneSafe }"></ng-container>
            }
            @case ('CELL_PHONE')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.contact?.cellPhoneNumber | phone, label: fieldLabel, safe: member?.cellPhoneSafe }"></ng-container>
            }
            @case ('OTHER_PHONE')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.contact?.otherPhoneNumber | phone, label: fieldLabel, safe: member?.otherPhoneSafe }"></ng-container>
            }
            @case ('FAX')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.contact?.faxNumber | phone, label: fieldLabel }"></ng-container>
            }
            @case ('PAGER')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.contact?.pagerNumber | phone, label: fieldLabel, safe: member?.pagerSafe }"></ng-container>
            }
            @case ('NOTIFICATION_LANGUAGE')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.contact?.notificationLanguage, label: fieldLabel }"></ng-container>
            }
            @case ('ADMINISTRATIVE_GENDER')   
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.administrativeGender?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('PREFERRED_NAME')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.name?.preferredName, label: fieldLabel }"></ng-container>
            }
            @case ('MIDDLE_NAME')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.name?.middleName, label: fieldLabel }"></ng-container>
            }
            @case ('EDUCATION_LEVEL')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.educationLevel?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('DEPENDENTS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.dependents, label: fieldLabel }"></ng-container>
            }
            @case ('EMPLOYMENT_STATUS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.employmentStatus?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('MARITAL_STATUS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.maritalStatus?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('RELIGIOUS_AFFILIATION')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.religiousAffiliation?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('VETERAN_STATUS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.veteranStatus?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('FAMILY_INCOME_STATUS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.familyIncomeUnknownDeclined === true ? ('YES' | translate) : member?.familyIncomeUnknownDeclined === false ? ('NO' | translate) : null, label: fieldLabel }"></ng-container>
            }
            @case ('ENGLISH_PROFICIENCY')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.englishProficiency?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('INTERPRETER_NEED')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.interpreterNeed?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('HOUSING')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.housingStatus?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('LIVES_ALONE')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.livesAlone === true ? ('YES' | translate) : member?.livesAlone === false ? ('NO' | translate) : null, label: fieldLabel }"></ng-container>
            }
            @case ('HOUSEHOLD_SIZE')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.householdSize, label: fieldLabel }"></ng-container>
            }
            @case ('ENHANCED_SERVICE_ELIGIBILITY')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.enhancedServices), label: fieldLabel }"></ng-container>
            }
            @case ('SPOKEN_LANGUAGES')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.spokenLanguages), label: fieldLabel }"></ng-container>
            }
            @case ('WRITTEN_LANGUAGES')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.memberWrittenLanguages), label: fieldLabel }"></ng-container>
            }
            @case ('READING_LANGUAGES')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.memberReadingLanguages), label: fieldLabel }"></ng-container>
            }
            @case ('RACES')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.races), label: fieldLabel }"></ng-container>
            }
            @case ('SEXUAL_ORIENTATION')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.sexualOrientation?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('TRIBAL_AFFILIATED')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.tribalAffiliated === true ? ('YES' | translate) : member?.tribalAffiliated === false ? ('NO' | translate) : null, label: fieldLabel }"></ng-container>
            }
            @case ('TRIBAL_AFFILIATIONS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.tribalAffiliations), label: fieldLabel }"></ng-container>
            }
            @case ('TRIBAL_ENROLLED')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.tribalEnrolled === true ? ('YES' | translate) : member?.tribalEnrolled === false ? ('NO' | translate) : null, label: fieldLabel }"></ng-container>
            }
            @case ('TRIBAL_ENROLLMENTS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.tribalEnrollments), label: fieldLabel }"></ng-container>
            }
            @case ('TOTAL_CHILDREN')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: totalChildren, label: fieldLabel }"></ng-container>
            }
            @case ('TOTAL_ADULTS')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: totalAdults, label: fieldLabel }"></ng-container>
            }
            @case ('PRIMARY_CAREGIVER')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.primaryCaregiver === true ? ('YES' | translate) : member?.primaryCaregiver === false ? ('NO' | translate) : null, label: fieldLabel }"></ng-container>
            }
            @case ('NAME_PRONOUN')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.namePronoun?.displayName, label: fieldLabel }"></ng-container>
            }
            @case ('NAME_PRONOUN_OTHER')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.namePronounOther, label: fieldLabel }"></ng-container>
            }
            @case ('INTERPRETER_NEED_OTHER')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: member?.interpreterNeedOther, label: fieldLabel }"></ng-container>
            }
            @case ('PREFERRED_CONTACT_METHODS')
            {           
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: convertPreferredContactMethodsToDisplayTexts(member?.preferredContactMethods), label: fieldLabel }"></ng-container>
            }
            @case ('OTHER_NAMES')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getOtherNames(member?.otherNames), label: fieldLabel }"></ng-container>
            }
            @case ('RACE_ETHNICITIES')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getDisplayNames(member?.raceEthnicities), label: fieldLabel }"></ng-container>
            }
            @case ('NOTIFICATION')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: getNotificationTypeText(member?.notificationType), label: fieldLabel }"></ng-container>
            }
            @case ('MEDICAL_INSURANCE')
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: insurancesText, label: fieldLabel }"></ng-container>
            }
            <!--Below are custom renderers for special properties that require special handling-->
            @case ('EMAIL')
            {
                <div class="row w-100" *ngIf="member?.contact?.email">
                    <div class="col-4 col-xl-4 ellipsis-text text-right pr-0" title="{{fieldLabel}}">{{fieldLabel}}: </div>
                    <div class="col-8 col-xl-8 ellipsis-text pl-2" title="{{member?.contact?.email}}">
                        <a href="mailto:{{member.contact.email}}" style="color: white;"
                        title="{{'NEW-EMAIL-HINT' | translate}} ({{member.contact.email}})"
                        target="_blank" class="data-value-text">{{member.contact.email}}
                        </a>
                    </div>
                </div>
            }
            @case ('VIDEO_PROVIDER')
            {
                <div class="row w-100" *ngIf="member?.contact?.preferredVideoProvider">
                    <div class="col-4 col-xl-4 ellipsis-text text-right pr-0" title="{{fieldLabel}}">{{fieldLabel}}: </div>
                    <div class="col-8 col-xl-8 ellipsis-text pl-2" title="{{member?.contact?.preferredVideoProvider?.name}}">
                        <span [ngClass]="{'pointer': member.contact.preferredVideoProvider.active}"
                        class="keyboard-accessible data-value-text"
                        *ngIf="member?.contact && member?.contact?.preferredVideoProvider" tabindex="0" role="link"
                        (keydown.enter)="member?.contact?.preferredVideoProvider?.active && openVideo(member?.contact?.preferredVideoProvider?.url)"
                        (keydown.space)="member?.contact?.preferredVideoProvider?.active && openVideo(member?.contact?.preferredVideoProvider?.url)"
                        (click)="member?.contact?.preferredVideoProvider?.active && openVideo(member?.contact?.preferredVideoProvider?.url)">{{member?.contact?.preferredVideoProvider?.name}}</span>
                    </div>
                </div>
            }
            @case ('COMPOSITE_RISK_SCORE')
            {
                <div class="row w-100">
                    <div class="col-4 col-xl-4 ellipsis-text text-right pr-0" title="{{fieldLabel}}">{{fieldLabel}}: </div>
                    <div class="col-8 col-xl-8 ellipsis-text pl-2">
                        <span class="badge badge-patient-header badge-pill badge-secondary float-left" title="{{'COMPOSITE-RISK-SCORE' | translate}}">{{compositeRiskScore}}
                        </span>
                    </div>
                </div>
            }
            @case ('DATE_OF_BIRTH')
            {
                @let formattedValue = member?.dateOfBirth ? (member.dateOfBirth | date) + ' (' + ('AGE' | translate) + ' ' + (member.dateOfBirth | age) + ')' : '';
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: formattedValue, label: fieldLabel }"></ng-container>
            }
            @case ('WORK_PHONE')
            {
                @let formattedValue = (member?.contact?.workPhoneNumber ?
                                    (member?.contact?.workPhoneNumber | phone) + 
                                    (member?.contact?.workPhoneNumberExtension ? ' ' + ('PHONE-EXTENSION-PREFIX' | translate) + ' ' + member?.contact?.workPhoneNumberExtension : '') : '');
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: formattedValue, label: fieldLabel, safe: member?.workPhoneSafe }"></ng-container>
            }
            @case ('FAMILY_INCOME')
            {
                <div class="row w-100" *ngIf="member?.familyIncome !== null && member?.familyIncome !== ''">
                    <div class="col-4 col-xl-4 ellipsis-text text-right pr-0" title="{{fieldLabel}}">{{fieldLabel}}: </div>
                    <div class="col-8 col-xl-8 ellipsis-text text-left pl-2">
                        <span title="${{member?.familyIncome | number}}" class="data-value-text">${{member?.familyIncome | number}}</span>
                    </div>
                </div>
            }
            @case ('POVERTY_LEVEL')
            {
                <div class="row w-100" *ngIf="member.familyIncome && member.povertyLevel">
                    <div class="col-4 col-xl-4 ellipsis-text text-right pr-0" title="{{fieldLabel}}">{{fieldLabel}}: </div>
                    <div class="col-8 col-xl-8 ellipsis-text pl-2">
                        <span
                            [ngClass]="{'poverty-yes': member.familyIncome<member.povertyLevel}" class="data-value-text">{{getPovertyText(member.familyIncome,member.povertyLevel)}}
                        </span>
                    </div>
                </div>
            }        
            @case ('ADDRESS')
            {
                @let address = member?.address;
                @if (address) 
                {
                    <div class="row w-100">
                        <div class="col-4 col-xl-4 ellipsis-text text-right pr-0" title="{{fieldLabel}}">{{fieldLabel}}: </div>
                        <div class="col-8 col-xl-8 ellipsis-text pl-2">
                            <div class="row" *ngIf="address?.streetLine">
                                <div class="col ellipsis-text" title="{{address.streetLine}}">
                                    <span class="data-value-text">{{address.streetLine}}</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="address?.streetLineAdditional">
                                <div class="col ellipsis-text" title="{{address.streetLineAdditional}}">
                                    <span class="data-value-text">{{address.streetLineAdditional}}</span>
                                </div>
                            </div>
                            <div class="row">
                                @let localityLine = HelperUtils.formatAddressLocalityLine(address);
                                @if (localityLine) 
                                {
                                <div class="col ellipsis-text" title="{{localityLine}}">
                                    <span class="data-value-text">{{ localityLine }}</span>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            }        
            @default
            {
                <ng-container *ngTemplateOutlet="standardRenderer; context: { value: field, label: ('MISSING-FORMATTING' | translate), class: 'bg-red' }"></ng-container>
            }
        }
    }
</ng-template>

<!-- Patient Header Standard Renderer -->
<ng-template #standardRenderer let-value="value" let-label="label" let-safe="safe" let-class="class">
    @if (value) 
    {
        <div class="row w-100">
            <div class="col-4 col-xl-4 ellipsis-text text-right pr-0 {{class}}" title="{{label}}">{{label}}: </div>
            <div class="col-8 col-xl-8 ellipsis-text pl-2 {{class}}" title="{{value}}"><span class="data-value-text">{{value}} <i *ngIf="safe" class="fas fa-shield-check" title="{{'SAFE' | translate}}"></i></span></div>
        </div>
    }
</ng-template>